import {SELECTED_DATA} from '../utils/constants';
import {initialState} from '../reducers'


const selectedDataReducer = (state, action) => {
  //console.log('#RDC-ClickedEl', action.type);
  switch (action.type) {
    case SELECTED_DATA:
      return action.selectedData
    default:
      return initialState.selectedData
  }
}

export default selectedDataReducer
//



// WEBPACK FOOTER //
// ./src/reducers/reducer-selectedData.js